<template>
  <div class="line-item-v2">
    <div class="d-flex mb-2 align-center justify-space-between">
      <div class="d-flex">
        <v-btn-toggle color="cyan" group>
          <!--  <v-btn
            color="cyan"
            class="custom-bold-button"
            value="header"
            @click="addParent"
            style="height: 32px !important"
          >
            Header
          </v-btn> -->
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="other"
            v-on:click="add_component(0)"
            style="height: 32px !important"
          >
            New Group
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <div class="custom-grey-border">
      <!-- Bottom scrollbar -->
      <div class="scrollbar-wrapper">
        <div
          class="scrollbar d-none"
          ref="topScrollbar"
          @scroll="onScroll('top')"
        >
          <div class="scroll-content"></div>
        </div>
      </div>
      <div class="content-wrapper">
        <div
          class="d-flex grey lighten-4"
          style="
            max-width: 2697px;
            overflow: scroll;
            position: sticky;
            top: 0px;
            z-index: 14;
          "
          ref="topScrollbar"
          @scroll="onScroll('top')"
        >
          <div
            class="color-custom-blue py-2 font-weight-500 text-center"
            style="min-width: 30px"
          ></div>
          <div
            class="color-custom-blue py-2 px-2 font-weight-500 text-left"
            style="min-width: 205px"
          >
            Brand
          </div>

          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 205px"
          >
            Model
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 205px"
          >
            Part
          </div>
          <div
            class="color-custom-blue py-2 px-2 font-weight-500 text-left"
            style="min-width: 116px"
          >
            Product Type
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            Currency
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            Cost
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            FLT
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            XR
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            GEAR
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            LAMP
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            ACC
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            UNIT COST
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            MARKUP %
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            UNIT SELLING
          </div>

          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            REQ. QTY
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            PRO. QTY
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2 d-flex"
            style="min-width: 116px"
          >
            UOM
            <v-icon
              small
              color="#24326d"
              class="ml-3"
              v-on:click="manageUnitDialog = true"
            >
              mdi-cog</v-icon
            >
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            PRO. UNIT SELL.
          </div>

          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            TOTAL COST
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            TOTAL SELLING
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500 px-2"
            style="min-width: 116px"
          >
            % TOTAL SALES
          </div>
          <div
            class="color-custom-blue py-2 font-weight-500"
            style="min-width: 80px"
          ></div>
        </div>
        <!-- Loop through each parent item (header) -->

        <Draggable
          tag="ul"
          v-model="selected_line_items2"
          class="line-item-drag-group mb-0"
          draggable=".line-item-drag"
          handle=".line-item-drag-icon"
          :force-fallback="true"
          ghost-class="line-item-ghost"
          group="parent-group"
          @start="drag = true"
          @end="onParentDragEnd"
          @change="onParentDragEnd"
        >
          <transition-group
            type="transition"
            :name="!drag ? 'flip-list' : null"
          >
            <li
              v-for="(parent, parentIndex) in selected_line_items2"
              :key="`line-item-drag-${parent.pUuid}`"
              class="line-item-drag px-0 mb-1 header_color"
              style="max-width: 2697px; overflow: scroll; display: grid"
              ref="rowScroll"
              @scroll="onScroll('row', parentIndex)"
            >
              <!-- Parent (Header) Row -->
              <div
                class="d-flex my-0 align-items-center pt-1 blue lighten-5 product_header"
              >
                <div
                  class="font-weight-600 text-center freeze-column"
                  style="min-width: 30px"
                >
                  <v-btn icon>
                    <v-icon
                      class="line-item-drag-icon cursor-move"
                      color="color-custom-blue"
                      >mdi-drag</v-icon
                    >
                  </v-btn>
                </div>
                <div class="text-left px-0 freeze-column w-100">
                  <v-text-field
                    v-model="parent.group_name"
                    class="line-item-header-text px-0"
                    :class="!parent.group_name ? 'error--text' : null"
                    placeholder="Group Name"
                    dense
                    filled
                    solo
                    flat
                    color="cyan"
                    v-on:keyup="calculate_total(), emit_values()"
                    v-on:keypress="(e) => manageLimit(e, parent.group_name)"
                    v-on:paste="(e) => onPaste(e, parent.group_name)"
                  >
                    <template v-slot:append>
                      <div class="text-right" style="color: black !important">
                        {{
                          parent?.group_name ? parent?.group_name.length : 0
                        }}/250
                      </div>
                    </template>
                  </v-text-field>
                </div>
                <div
                  class="text-left px-0"
                  style="width: calc(100% - 70px)"
                ></div>
                <div class="last-child" style="min-width: 40px">
                  <v-btn icon @click="openDeleteConfirmation(parentIndex)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- Subheader Items -->
              <Draggable
                tag="ul"
                v-model="parent.children"
                class="line-item-drag-group mb-0"
                draggable=".line-item-drag"
                handle=".line-item-drag-icon"
                ghost-class="line-item-ghost"
                group="child-group"
                :force-fallback="true"
                @start="drag = true"
                @end="onChildDragEnd"
                @change="onChildDragEnd"
                :disabled="parent?.children?.length == 1 ? true : false"
              >
                <transition-group
                  type="transition"
                  :name="!drag ? 'flip-list' : null"
                >
                  <li
                    v-for="(child, childIndex) in parent.children"
                    :key="`child-drag-${parent.pUuid}-${child.cUuid}`"
                    class="line-item-drag px-0"
                  >
                    <div
                      class="d-flex my-0 align-items-center pt-1 blue lighten-5"
                    >
                      <div
                        class="font-weight-600 text-center freeze-column"
                        style="min-width: 30px"
                      >
                        <v-btn icon>
                          <v-icon
                            class="line-item-drag-icon cursor-move"
                            color="color-custom-blue"
                            >mdi-drag</v-icon
                          >
                        </v-btn>
                      </div>
                      <div
                        class="text-left px-0 freeze-column w-100"
                        style="z-index: 7 !important"
                      >
                        <TextAreaField
                          row-height="3"
                          no-resize
                          rows="3"
                          dense
                          filled
                          color="cyan"
                          v-model="child.Subheader"
                          placeholder="Subheader Name"
                          solo
                          flat
                          counter="5000"
                          v-on:keyup="emit_values()"
                        />
                        <!--  <TextField
                            dense
                            filled
                            placeholder="Subheader Name"
                            solo
                            flat
                            counter="5000"
                            v-model="child.Subheader"
                            color="cyan"
                            class="line-item-header-text px-0"
                            :maxlength="5000"
                            v-on:keyup="emit_values()"
                          /> -->
                        <!-- <v-text-field
                          v-model="child.Subheader"
                          class="line-item-header-text px-0"
                          placeholder="Subheader Name"
                          dense
                          filled
                          solo
                          flat
                          color="cyan"
                          v-on:keyup="emit_values()"
                        /> -->
                      </div>
                      <div
                        class="text-left px-0"
                        style="width: calc(100% - 70px)"
                      ></div>
                      <div
                        class="last-child"
                        style="min-width: 40px"
                        v-if="false"
                      >
                        <v-btn icon @click="openDeleteConfirmation(childIndex)">
                          <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <!-- Nested Items -->
                    <Draggable
                      tag="ul"
                      v-model="child.header_item"
                      class="line-item-drag-group mb-0"
                      draggable=".line-item-drag"
                      handle=".line-item-drag-icon"
                      ghost-class="line-item-ghost"
                      group="item-group"
                      @start="drag = true"
                      @end="onItemDragEnd"
                      @change="onItemDragEnd"
                    >
                      <transition-group
                        type="transition"
                        :name="!drag ? 'flip-list' : null"
                      >
                        <li
                          v-for="(item, itemIndex) in child.header_item"
                          :key="`item-drag-${parent.pUuid}-${child.cUuid}-${item.ccUuid}`"
                          class="line-item-drag px-0"
                        >
                          <div class="d-flex my-0 align-items-center">
                            <div
                              class="font-weight-600 text-center freeze-column"
                              style="min-width: 30px"
                            >
                              <v-btn width="30" icon style="background: #fff">
                                <v-icon
                                  class="line-item-drag-icon cursor-move"
                                  color="color-custom-blue"
                                  >mdi-drag</v-icon
                                >
                              </v-btn>
                            </div>
                            <!-- Editable fields for each item -->
                            <div
                              class="text-left pe-1 freeze-column"
                              style="min-width: 205px"
                            >
                              <v-combobox
                                dense
                                color="cyan"
                                filled
                                v-model="item.brand"
                                v-on:change="calculate_total()"
                                :items="v2BrandList"
                                placeholder="Select Brand"
                                item-value="text"
                                item-text="text"
                                solo
                                flat
                                hide-details
                                :return-object="false"
                              />
                            </div>
                            <div
                              class="text-left px-1 freeze-column"
                              style="min-width: 205px"
                            >
                              <v-combobox
                                dense
                                color="cyan"
                                filled
                                v-model="item.model"
                                v-on:change="calculate_total()"
                                :items="v2ModelList"
                                placeholder="Select Model"
                                solo
                                flat
                                hide-details
                                :return-object="false"
                              />
                            </div>
                            <div
                              class="text-left px-1 freeze-column"
                              style="min-width: 205px"
                            >
                              <v-combobox
                                dense
                                color="cyan"
                                filled
                                v-model="item.part"
                                :items="v2PartList"
                                placeholder="Select Part"
                                v-on:change="calculate_total()"
                                solo
                                flat
                                hide-details
                                :return-object="false"
                              />
                            </div>
                            <div
                              class="text-left px-1 freeze-column"
                              style="min-width: 116px"
                            >
                              <v-autocomplete
                                dense
                                color="cyan"
                                filled
                                id="costing-product"
                                :items="
                                  getFilteredProductType(
                                    child.header_item,
                                    item.product
                                  )
                                "
                                v-model.trim="item.product"
                                placeholder="Select Product"
                                style="z-index: 9 !important"
                                solo
                                flat
                                item-color="cyan"
                                item-text="value"
                                item-value="value"
                                hide-details
                                v-on:change="
                                  disabledSelection(item, item.product);
                                  calculate_total();
                                "
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-html="'No Product Found.'"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>

                              <!--    <v-combobox
                                dense
                                color="cyan"
                                filled
                                v-model="item.product"
                                :items="v2ProductType"
                                placeholder="Select Product"
                                solo
                                flat
                                hide-details
                                v-on:change="calculate_total()"
                                :return-object="false"
                              /> -->
                            </div>
                            <div
                              class="text-left px-1 highlighted"
                              style="min-width: 116px"
                            >
                              <v-autocomplete
                                dense
                                color="cyan"
                                filled
                                id="costing-currency"
                                :items="v2CurrencyList"
                                v-model.trim="item.cost_currency"
                                style="z-index: 12 !important"
                                placeholder="Select Currency"
                                solo
                                flat
                                item-color="cyan"
                                item-text="text"
                                item-value="value"
                                hide-details
                                v-on:change="calculate_total()"
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-html="'No Currency Found.'"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </div>
                            <div
                              class="text-left px-1 highlighted"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                :value="
                                  Number(item.cost) > 0 ? item.cost : null
                                "
                                @input="item.cost = $event"
                                class="line-item-header-text px-0"
                                placeholder="Cost"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                v-on:keyup="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="limitDecimal($event, item.cost)"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                :value="Number(item.flt) > 0 ? item.flt : null"
                                @input="item.flt = $event"
                                class="line-item-header-text px-0"
                                placeholder="FLT"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                v-on:keyup="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="limitDecimal($event, item.flt)"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keyup="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="limitDecimal($event, item.xr)"
                                :value="Number(item.xr) > 0 ? item.xr : null"
                                @input="item.xr = $event"
                                class="line-item-header-text px-0"
                                placeholder="XR"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keyup="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="limitDecimal($event, item.gear)"
                                :value="
                                  Number(item.gear) > 0 ? item.gear : null
                                "
                                @input="item.gear = $event"
                                class="line-item-header-text px-0"
                                placeholder="GEAR"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keyup="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="limitDecimal($event, item.lamp)"
                                :value="
                                  Number(item.lamp) > 0 ? item.lamp : null
                                "
                                @input="item.lamp = $event"
                                class="line-item-header-text px-0"
                                placeholder="LAMP"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keyup="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'cost',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="limitDecimal($event, item.acc)"
                                :value="Number(item.acc) > 0 ? item.acc : null"
                                @input="item.acc = $event"
                                class="line-item-header-text px-0"
                                placeholder="ACC"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                              />
                            </div>
                            <div
                              class="text-left px-1 highlighted"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                :value="
                                  Number(item.unit_cost) > 0
                                    ? item.unit_cost
                                    : null
                                "
                                @input="item.unit_cost = $event"
                                class="line-item-header-text px-0"
                                placeholder="Unit Cost"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                readonly
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                v-on:keyup="
                                  calculate_total(
                                    'margin',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'margin',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                type="number"
                                v-on:keypress="
                                  limitDecimal($event, item.margin)
                                "
                                v-model="item.margin"
                                class="line-item-header-text px-0"
                                placeholder="Markup"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                              />
                            </div>
                            <div
                              class="text-left px-1 highlighted"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keypress="
                                  limitDecimal($event, item.unit_selling)
                                "
                                :value="
                                  Number(item.unit_selling) > 0
                                    ? item.unit_selling
                                    : null
                                "
                                @input="item.unit_selling = $event"
                                class="line-item-header-text px-0"
                                placeholder="Unit Selling"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                readonly
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keyup="
                                  calculate_total(
                                    'required_quantity',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'required_quantity',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="
                                  limitDecimal($event, item.required_quantity)
                                "
                                v-model="item.required_quantity"
                                class="line-item-header-text px-0"
                                placeholder="Required Quantity"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keyup="
                                  calculate_total(
                                    'proquantity',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'proquantity',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:keypress="
                                  limitDecimal($event, item.proquantity)
                                "
                                v-model="item.proquantity"
                                class="line-item-header-text px-0"
                                placeholder="Quantity"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-autocomplete
                                :menu-props="{
                                  bottom: true,
                                  offsetY: true,
                                  contentClass: 'custom-z-index',
                                }"
                                dense
                                color="cyan"
                                filled
                                id="uom"
                                :items="v2UomList"
                                v-model.trim="item.uom"
                                placeholder="UOM"
                                solo
                                flat
                                item-color="cyan"
                                item-text="text"
                                item-value="text"
                                hide-details
                                v-on:change="calculate_total()"
                              >
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-html="'No UOM Found.'"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </div>
                            <div
                              class="text-left px-1 highlighted"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keypress="
                                  limitDecimal($event, item.pro_unit_selling)
                                "
                                :value="
                                  Number(item.pro_unit_selling) > 0
                                    ? item.pro_unit_selling
                                    : null
                                "
                                @input="
                                  item.pro_unit_selling = $event;
                                  item.isBackwardUpdated = true;
                                "
                                class="line-item-header-text px-0"
                                placeholder="Pro.Unit Selling"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                v-on:keyup="
                                  calculate_total(
                                    'selling',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                                v-on:change="
                                  calculate_total(
                                    'selling',
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                              />
                            </div>
                            <div
                              class="text-left px-1 highlighted"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keypress="
                                  limitDecimal($event, item.total_cost)
                                "
                                :value="
                                  Number(item.total_cost) > 0
                                    ? item.total_cost
                                    : null
                                "
                                @input="item.total_cost = $event"
                                class="line-item-header-text px-0"
                                placeholder="Total Cost"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                readonly
                                v-on:keyup="calculate_total()"
                              />
                            </div>
                            <div
                              class="text-left px-1 highlighted"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keypress="
                                  limitDecimal($event, item.total_selling)
                                "
                                :value="
                                  Number(item.total_selling) > 0
                                    ? item.total_selling
                                    : null
                                "
                                @input="item.total_selling = $event"
                                class="line-item-header-text px-0"
                                placeholder="Total Selling"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                readonly
                                v-on:keyup="calculate_total()"
                              />
                            </div>
                            <div
                              class="text-left px-1"
                              style="min-width: 116px"
                            >
                              <v-text-field
                                type="number"
                                v-on:keypress="
                                  limitDecimal($event, item.total_sales)
                                "
                                :value="
                                  Number(item.total_sales) > 0
                                    ? item.total_sales
                                    : null
                                "
                                @input="item.total_sales = $event"
                                class="line-item-header-text px-0"
                                placeholder="Total Sales"
                                append-icon="mdi-percent-outline"
                                dense
                                filled
                                solo
                                flat
                                color="cyan"
                                readonly
                                v-on:keyup="calculate_total()"
                              />
                            </div>
                            <div class="last-child" style="min-width: 80px">
                              <!-- Button to remove child -->
                              <v-btn
                                :disabled="
                                  child?.header_item?.length == 1 ? true : false
                                "
                                icon
                                @click="
                                  removeChild(
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                              >
                                <v-icon color="red">mdi-delete</v-icon>
                              </v-btn>
                              <!-- Button to add a new child -->
                              <v-btn
                                icon
                                @click="
                                  addChildItem(
                                    parentIndex,
                                    childIndex,
                                    itemIndex
                                  )
                                "
                              >
                                <v-icon color="green">mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </li>
                      </transition-group>
                    </Draggable>
                    <div class="d-flex">
                      <div style="width: 2165px"></div>
                      <div style="width: 116px" class="font-weight-600 text-h6">
                        Total
                      </div>
                      <div style="width: 116px">
                        {{ formatMoney(child.p_unit_selling) }}
                      </div>
                      <div style="width: 116px">
                        {{ formatMoney(child.p_total_cost) }}
                      </div>
                      <div style="width: 116px" class="font-weight-600 text-h6">
                        {{ formatMoney(child.p_total_saling) }}
                      </div>
                      <div style="width: 116px">
                        {{ child.p_total_sales }} %
                      </div>
                    </div>
                  </li>
                </transition-group>
              </Draggable>
            </li>
          </transition-group>
        </Draggable>
        <template v-if="!selected_line_items2.length">
          <div class="custom-border-top p-3">
            <p
              class="m-0 p-4 font-size-16 font-weight-500 light-gray-background custom-grey-border d-flex align-center"
            >
              <v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
              Oops... Nothing Found.
            </p>
          </div>
        </template>
      </div>
    </div>

    <!-- header component btn -->
    <div class="d-flex mt-2">
      <div class="d-flex">
        <v-btn-toggle color="cyan" group>
          <!--   <v-btn
            color="cyan"
            class="custom-bold-button"
            value="header"
            @click="addParent"
            style="height: 32px !important"
          >
            Header
          </v-btn> -->
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="other"
            v-on:click="add_component(0)"
            style="height: 32px !important"
          >
            New Group
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>

    <!-- total of line item -->
    <div>
      <table width="100%" style="table-layout: fixed">
        <tbody>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600 text-h5"
            >
              Total Selling
            </td>
            <td width="15%" valign="middle" align="center"></td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600 text-h5"
            >
              <v-tooltip top content-class="custom-top-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <label
                    v-bind="attrs"
                    v-on="on"
                    class="font-size-16 font-weight-600 m-0"
                    >{{ formatMoney(total_selling) }}</label
                  >
                </template>
                <span>Sum of All Total Selling</span>
              </v-tooltip>
            </td>
          </tr>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Total Cost Value
            </td>
            <td width="15%" valign="middle" align="center"></td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              <v-tooltip top content-class="custom-top-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <label
                    v-bind="attrs"
                    v-on="on"
                    class="font-size-16 font-weight-600 m-0"
                    >{{ formatMoney(total_cost_value) }}</label
                  >
                </template>
                <span>Sum of All Total Cost</span>
              </v-tooltip>
            </td>
          </tr>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Total Margin
            </td>
            <td width="15%" valign="middle" align="center"></td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              <v-tooltip top content-class="custom-top-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <label
                    v-bind="attrs"
                    v-on="on"
                    class="font-size-16 font-weight-600 m-0"
                    >{{ formatNumber(total_margin) }} %</label
                  >
                </template>
                <span>((Total Selling - Total Cost) / Total Selling )*100</span>
              </v-tooltip>
            </td>
          </tr>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Percentage Discount
            </td>
            <td width="15%" valign="middle" align="center">
              <div class="d-flex">
                <v-text-field
                  hide-details
                  class="line-item-header-text px-0"
                  placeholder="Percentage Discount"
                  dense
                  filled
                  solo
                  flat
                  v-model="discount_value"
                  v-on:keyup="calculate_total()"
                  v-on:keypress="limitDecimal($event, discount_value)"
                  color="cyan"
                />

                <v-icon color="black" size="24" class="ml-2">
                  mdi-percent</v-icon
                >
                <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-if="false"
                  :items="discount_type_list"
                  v-model="discount_type"
                  hide-details
                  item-text="type"
                  item-value="value"
                  item-color="cyan"
                  class="line-item-header-text discount-type text-h6 px-0"
                  placeholder="Type"
                  dense
                  filled
                  solo
                  flat
                  v-on:change="calculate_total()"
                  color="cyan"
                />
              </div>
            </td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(main_discount) }}
            </td>
          </tr>
          <tr>
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Lump Sum Discount
            </td>
            <td width="15%" valign="middle" align="center">
              <div class="d-flex">
                <v-text-field
                  hide-details
                  class="line-item-header-text px-0"
                  placeholder="Lump Sum Discount"
                  dense
                  filled
                  solo
                  flat
                  v-model="lump_discount_value"
                  v-on:keyup="calculate_total()"
                  v-on:keypress="limitDecimal($event, lump_discount_value)"
                  color="cyan"
                />

                <v-icon color="black" size="24" class="ml-2">
                  mdi-currency-usd</v-icon
                >
                <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-if="false"
                  :items="discount_type_list"
                  v-model="lump_discount_type"
                  hide-details
                  item-text="type"
                  item-value="value"
                  item-color="cyan"
                  class="line-item-header-text discount-type text-h6 px-0"
                  placeholder="Type"
                  dense
                  filled
                  solo
                  flat
                  v-on:change="calculate_total()"
                  color="cyan"
                />
              </div>
            </td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(lump_sum_discount) }}
            </td>
          </tr>

          <tr v-if="false">
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              Discounted Total Selling
            </td>
            <td width="15%" valign="middle" align="center"></td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600"
            >
              {{ formatMoney(discounted_total_selling) }}
            </td>
          </tr>
          <tr class="font-size-19">
            <td
              width="70%"
              valign="middle"
              align="right"
              class="font-weight-600 text-h5"
            >
              Grand Total
            </td>
            <td width="15%" valign="middle" align="center"></td>
            <td
              width="15%"
              valign="middle"
              align="right"
              class="font-weight-600 text-h5"
            >
              {{ formatMoney(grand_total) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Confirmation Dialog -->
    <v-dialog v-model="showDeleteConfirmation" max-width="600px">
      <DeleteSmallConfirm
        :message="'Are you sure you want to delete this item?'"
        @success="handleDelete"
        @cancel="handleCancel"
      />
    </v-dialog>
    <ManageUnit
      :u-dialog="manageUnitDialog"
      :unit="v2UomList"
      v-on:close-dialog="manageUnitDialog = false"
      v-on:get-product-unit="getOptions"
    ></ManageUnit>
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin.js";
import {
  SET_LINE_ITEM,
  SET_CALCULATION,
  SET_CALCULATION_LOADING,
} from "@/core/services/store/line.item.v2.module";
import Draggable from "vuedraggable";
import DeleteSmallConfirm from "@/view/pages/partials/DeleteSmallConfirm";
import moment from "moment-timezone";
import { v4 as uuidv4 } from "uuid";
import { mapGetters } from "vuex";
import {
  toBtxNumber /* , toBtxFixed */,
} from /* toRoundUp */ "@/core/services/common.service";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import ManageUnit from "@/view/pages/partials/Manage-Product-Unit.vue";
import { SET_UOM } from "@/core/services/store/line.item.v2.module";
import { QUERY } from "@/core/services/store/request.module";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  name: "line-item-v1",
  mixins: [CommonMixin],
  data() {
    return {
      isSyncingScroll: false,
      manageUnitDialog: false,
      showDeleteConfirmation: false,
      drag: false,
      firstParentAdded: null,
      brandList: ["JRLite", "ELDOLED", "MEANWELL"],
      modelList: [
        "COVEFLEX1808",
        "AP-293C-P",
        "AC022-AP",
        "LINEARDRIVE",
        "LPV",
      ],
      partList: [
        "RURE IQ LED STRIPS",
        "ALUM PROFILE",
        "SS CLIPS",
        "LIN210",
        "60-24",
      ],
      productType: [
        {
          value: "Brand",
          disabled: false,
        },
        {
          value: "Accessories",
          disabled: false,
        },
      ],
      currencyListType: ["SGD", "USD"],
      uomListType: [],
      discount_value: null,
      lump_discount_value: null,
      discount_type: 2,
      lump_discount_type: 1,
      discount_type_list: [
        { type: "%", value: 2 },
        { type: "$", value: 1 },
      ],
      total_selling: 0,
      total_cost_value: 0,
      total_margin: 0,
      total_sales: 0,
      main_discount: 0,
      lump_sum_discount: 0,
      discounted_total_selling: 0,
      grand_total: 0,
      show1: false,
      selected_line_items2: [],
      deleteIndex: 0,
    };
  },

  methods: {
    manageLimit(e, textInputValue) {
      if (textInputValue && textInputValue.length > 249) {
        e.preventDefault();
      }
    },
    onPaste(e, textInputValue) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = textInputValue;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 249) {
        let trimValue = finalval.substring(0, 250);
        textInputValue = trimValue;
        e.preventDefault();
      }
    },
    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "product/options",
        })
        .then((response) => {
          if (
            _this.lodash.isEmpty(response.data) === false &&
            response.data.unit
          ) {
            _this.uomListType = response.data.unit;
            this.$store.commit(SET_UOM, _this.uomListType);
            //  console.log(_this.unitList);
          }
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    addParent() {
      let len = this.selected_line_items2?.length + 1;
      this.selected_line_items2.push({
        order: len,
        isHeader: true,
        pIndex: uuidv4(),
        pUuid: uuidv4(),
        group_name: "Parent Group Name new",
        children: [],
      });
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    removeParent(parentIndex) {
      this.selected_line_items2.splice(parentIndex, 1);
      this.updateParentOrder();
      this.calculate_total();
      this.emit_values();
    },
    addChildItem(parentIndex, childIndex) {
      this.selected_line_items2[parentIndex].children[
        childIndex
      ].header_item.push({
        ccIndex: uuidv4(),
        ccUuid: uuidv4(),
        model: null,
        part: null,
        product: null,
        cost_currency: null,
        cost: null,
        flt: null,
        xr: null,
        gear: null,
        lamp: null,
        acc: null,
        unit_cost: null,
        margin: null,
        unit_selling: null,
        required_quantity: 1,
        proquantity: 1,
        uom: null,
        pro_unit_selling: null,
        total_cost: null,
        total_selling: null,
        total_sales: null,
        isBackwardUpdated: false,
      });
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    removeChild(parentIndex, childIndex, itemIndex) {
      if (
        this.selected_line_items2[parentIndex]?.children[childIndex]
          ?.header_item.length > 1
      ) {
        this.selected_line_items2[parentIndex].children[
          childIndex
        ].header_item.splice(itemIndex, 1);
        this.calculate_total();
        this.emit_values();
      }
    },
    add_component() {
      let len = this.selected_line_items2?.length + 1;
      this.selected_line_items2.push({
        order: len,
        isHeader: true,
        pIndex: uuidv4(),
        pUuid: uuidv4(),
        group_name: null,
        children: [],
      });

      let lastIndex = this.selected_line_items2?.length - 1;
      if (lastIndex < 0) {
        lastIndex = 0;
      }
      this.selected_line_items2[lastIndex]?.children.push({
        Subheader: null,
        isSubHeader: true,
        cIndex: uuidv4(),
        cUuid: uuidv4(),
        header_item: [
          {
            ccIndex: uuidv4(),
            ccUuid: uuidv4(),
            model: null,
            part: null,
            product: null,
            cost_currency: null,
            cost: null,
            flt: null,
            xr: null,
            gear: null,
            lamp: null,
            acc: null,
            unit_cost: null,
            margin: null,
            unit_selling: null,
            required_quantity: 1,
            proquantity: 1,
            uom: null,
            pro_unit_selling: null,
            total_cost: null,
            total_selling: null,
            total_sales: null,
            isBackwardUpdated: false,
          },
        ],
        p_unit_selling: 0,
        p_total_sales: 0,
        p_total_saling: 0,
        p_total_cost: 0,
      });

      this.$nextTick(() => {
        this.emit_values();
      });
    },

    openDeleteConfirmation(index) {
      this.deleteIndex = index;
      this.showDeleteConfirmation = true;
    },
    handleDelete() {
      this.removeParent(this.deleteIndex);
      this.showDeleteConfirmation = false;
    },

    handleCancel() {
      this.showDeleteConfirmation = false;
    },
    onScroll(source, index = null) {
      if (this.isSyncingScroll) return;
      this.isSyncingScroll = true;

      let scrollLeftNew = 0;

      // Identify scroll source
      if (source === "top") {
        scrollLeftNew = this.$refs.topScrollbar.scrollLeft;
      } else if (source === "row") {
        scrollLeftNew = this.$refs.rowScroll[index].scrollLeft;
      }

      // Sync top scrollbar
      if (this.$refs.topScrollbar.scrollLeft !== scrollLeftNew) {
        this.$refs.topScrollbar.scrollLeft = scrollLeftNew;
      }

      // Sync all rows
      this.$refs?.rowScroll?.forEach((row) => {
        if (row.scrollLeft !== scrollLeftNew) {
          row.scrollLeft = scrollLeftNew;
        }
      });

      requestAnimationFrame(() => {
        this.isSyncingScroll = false;
      });
    },

    // syncScrollFromBottom() {
    //   this.$refs.topScrollbar.scrollLeft =
    //     this.$refs.scrollContainer.scrollLeft;
    // },
    // syncScrollFromTop() {
    //   this.$refs.scrollContainer.scrollLeft =
    //     this.$refs.topScrollbar.scrollLeft;
    // },

    calculate_total(
      type = null,
      parentIndex = null,
      childIndex = null,
      itemIndex = null
    ) {
      this.$store.dispatch(SET_CALCULATION_LOADING, true);

      // STEP A: If a specific row is being edited, recalculate ONLY that specific row
      if (
        parentIndex !== null &&
        childIndex !== null &&
        itemIndex !== null &&
        type !== null
      ) {
        const lineItem = this.selected_line_items2[parentIndex];
        const child = lineItem?.children?.[childIndex];
        const row = child?.header_item?.[itemIndex];

        if (row) {
          const cost = toBtxNumber(row.cost) || 0;
          const flt = toBtxNumber(row.flt) || 1;
          const xr = toBtxNumber(row.xr) || 1;
          const gear = toBtxNumber(row.gear) || 0;
          const lamp = toBtxNumber(row.lamp) || 0;
          const acc = toBtxNumber(row.acc) || 0;

          const calculatedValue = cost * flt * xr + (gear + lamp + acc);
          row.unit_cost = this.accountingToFixedFive(
            toBtxNumber(calculatedValue)
          );
          const unit_cost = toBtxNumber(row.unit_cost) || 0;

          const required_quantity = toBtxNumber(row.required_quantity) || 0;
          const proquantity = toBtxNumber(row.proquantity) || 1;

          if (type === "selling") {
            // User manually typed Pro.Unit Selling
            row.isBackwardUpdated = true;
            let unitsellValue = 0;
            if (required_quantity > 0 && proquantity > 0) {
              unitsellValue =
                (toBtxNumber(row.pro_unit_selling) * proquantity) /
                required_quantity;
            }
            row.unit_selling = this.accountingToFixed(unitsellValue);
            unitsellValue = toBtxNumber(row.unit_selling);

            const marginPercent =
              unitsellValue > 0
                ? ((unitsellValue - unit_cost) / unitsellValue) * 100
                : 0;
            row.margin = this.accountingToFixed(marginPercent);
          } else if (type === "margin") {
            // User manually typed Margin
            row.isBackwardUpdated = false;
            const markup = (toBtxNumber(row.margin) || 0) / 100;
            let unitsellValue =
              unit_cost !== 0 && markup !== 1 ? unit_cost / (1 - markup) : 0;
            row.unit_selling = this.accountingToFixed(unitsellValue);

            let proRatedUnitSell =
              proquantity !== 0
                ? (toBtxNumber(row.unit_selling) * required_quantity) /
                  proquantity
                : 0;
            row.pro_unit_selling = this.accountingToFixed(proRatedUnitSell);
          } else if (type === "cost") {
            // User edited Cost / FLT / XR / Gear / Lamp / Acc
            if (row.isBackwardUpdated) {
              const unitsellValue = toBtxNumber(row.unit_selling) || 0;
              const marginPercent =
                unitsellValue > 0
                  ? ((unitsellValue - unit_cost) / unitsellValue) * 100
                  : 0;
              row.margin = this.accountingToFixed(marginPercent);
            } else {
              const markup = (toBtxNumber(row.margin) || 0) / 100;
              let unitsellValue =
                unit_cost !== 0 && markup !== 1 ? unit_cost / (1 - markup) : 0;
              row.unit_selling = this.accountingToFixed(unitsellValue);

              let proRatedUnitSell =
                proquantity !== 0
                  ? (toBtxNumber(row.unit_selling) * required_quantity) /
                    proquantity
                  : 0;
              row.pro_unit_selling = this.accountingToFixed(proRatedUnitSell);
            }
          } else if (type === "required_quantity" || type === "proquantity") {
            // User edited Quantities
            if (row.isBackwardUpdated) {
              let unitsellValue = 0;
              if (required_quantity > 0 && proquantity > 0) {
                unitsellValue =
                  (toBtxNumber(row.pro_unit_selling) * proquantity) /
                  required_quantity;
              }
              row.unit_selling = this.accountingToFixed(unitsellValue);
              unitsellValue = toBtxNumber(row.unit_selling);

              const marginPercent =
                unitsellValue > 0
                  ? ((unitsellValue - unit_cost) / unitsellValue) * 100
                  : 0;
              row.margin = this.accountingToFixed(marginPercent);
            } else {
              let proRatedUnitSell =
                proquantity !== 0
                  ? (toBtxNumber(row.unit_selling) * required_quantity) /
                    proquantity
                  : 0;
              row.pro_unit_selling = this.accountingToFixed(proRatedUnitSell);
            }
          }
        }
      }

      // STEP B: GLOBAL CALCULATION (Totals, Brand Multipliers, Subtotals, Sales %, Discounts)
      // NOTE: This global step preserves and NEVER mutates any row's unit_cost, margin, unit_selling, or pro_unit_selling!

      this.total_sales = 0;
      this.total_selling = 0;
      this.total_cost_value = 0;
      this.total_margin = 0;

      let requiredQtyByGroup = {};

      // 1. Find Brand Quantity for each Parent Group
      for (let i = 0; i < this.selected_line_items2?.length; i++) {
        const lineItem = this.selected_line_items2[i];
        if (!lineItem || !lineItem.pUuid) continue;

        for (let j = 0; j < lineItem.children?.length; j++) {
          const child = lineItem.children[j];
          if (!child) continue;

          for (let k = 0; k < child.header_item?.length; k++) {
            const row = child.header_item[k];
            if (!row) continue;

            if (row.product === "Brand") {
              requiredQtyByGroup[lineItem.pUuid] =
                toBtxNumber(row.required_quantity) || 0;
              break;
            }
          }
        }
      }

      // 2. Calculate row totals and group subtotals
      for (let i = 0; i < this.selected_line_items2?.length; i++) {
        const lineItem = this.selected_line_items2[i];
        if (!lineItem || !lineItem.pUuid) continue;

        const requiredQtyForBrand = requiredQtyByGroup[lineItem.pUuid] || 0;

        for (let j = 0; j < lineItem.children?.length; j++) {
          const child = lineItem.children[j];
          if (!child) continue;

          let totalProRatedUnitSell = 0;
          let totalCost = 0;
          let totalSelling = 0;

          for (let k = 0; k < child.header_item?.length; k++) {
            const row = child.header_item[k];
            if (!row) continue;

            const unit_cost = toBtxNumber(row.unit_cost) || 0;
            const required_quantity = toBtxNumber(row.required_quantity) || 0;

            const total_cost = unit_cost * required_quantity;
            row.total_cost = this.accountingToFixed(toBtxNumber(total_cost));

            const total_selling =
              toBtxNumber(row.pro_unit_selling) * requiredQtyForBrand;
            row.total_selling = this.accountingToFixed(total_selling);

            totalProRatedUnitSell += toBtxNumber(row.pro_unit_selling) || 0;
            totalCost += total_cost;
            totalSelling += total_selling;
          }

          child.p_unit_selling = this.accountingToFixed(totalProRatedUnitSell);
          child.p_total_saling = this.accountingToFixed(totalSelling);
          child.p_total_cost = this.accountingToFixed(totalCost);

          this.total_selling += totalSelling;
          this.total_cost_value += totalCost;
        }
      }

      // STEP 3 Margin
      this.total_margin =
        this.total_selling && this.total_cost_value
          ? ((this.total_selling - this.total_cost_value) /
              this.total_selling) *
            100
          : 0;

      // Discounts — unchanged
      this.main_discount = 0;
      if (this.discount_type == 1) {
        if (this.discount_value > this.total_selling) {
          this.discount_value = this.total_selling;
        }
        this.main_discount = toBtxNumber(this.discount_value);
      }
      if (this.discount_type == 2) {
        if (this.discount_value > 100) this.discount_value = 100;
        this.main_discount =
          (toBtxNumber(this.total_selling) * toBtxNumber(this.discount_value)) /
          100;
      }

      this.lump_sum_discount = 0;
      if (this.lump_discount_type == 1) {
        if (this.lump_discount_value > this.total_selling) {
          this.lump_discount_value = this.total_selling;
        }
        this.lump_sum_discount = toBtxNumber(this.lump_discount_value);
      }
      if (this.lump_discount_type == 2) {
        if (this.lump_discount_value > 100) this.lump_discount_value = 100;
        this.lump_sum_discount =
          (toBtxNumber(this.total_selling) *
            toBtxNumber(this.lump_discount_value)) /
          100;
      }

      this.grand_total =
        this.total_selling - this.main_discount - this.lump_sum_discount;
      this.grand_total = toBtxNumber(this.grand_total);

      // Sales %
      for (let a = 0; a < this.selected_line_items2?.length; a++) {
        const lineItem = this.selected_line_items2[a];
        if (!lineItem) continue;

        let totalSales = 0;

        for (let b = 0; b < lineItem.children?.length; b++) {
          const child = lineItem.children[b];
          if (!child) continue;

          for (let c = 0; c < child.header_item?.length; c++) {
            const row = child.header_item[c];
            if (!row) continue;

            const total_selling = toBtxNumber(row.total_selling) || 0;

            const total_sales =
              this.total_selling > 0
                ? (total_selling / this.total_selling) * 100
                : 0;

            row.total_sales = this.accountingToFixed(total_sales);
            totalSales += total_sales;
          }

          child.p_total_sales = this.accountingToFixed(totalSales);
        }
      }

      this.emit_values();
    },

    // ---------------- OLD CODE BACKUP ----------------
    old_calculate_total(
      type = null,
      parentIndex = null,
      childIndex = null,
      itemIndex = null
    ) {
      this.$store.dispatch(SET_CALCULATION_LOADING, true);
      // ---------------- ONLY SINGLE ROW UPDATE MODE ----------------
      if (
        type === "selling" &&
        parentIndex !== null &&
        childIndex !== null &&
        itemIndex !== null
      ) {
        const lineItem = this.selected_line_items2[parentIndex];
        if (!lineItem) {
          this.$store.dispatch(SET_CALCULATION_LOADING, false);
          return;
        }

        const child = lineItem.children[childIndex];
        if (!child) {
          this.$store.dispatch(SET_CALCULATION_LOADING, false);
          return;
        }

        const superChildRow = child.header_item[itemIndex];
        if (!superChildRow) {
          this.$store.dispatch(SET_CALCULATION_LOADING, false);
          return;
        }

        const cost = toBtxNumber(superChildRow.cost) || 0;
        const flt = toBtxNumber(superChildRow.flt) || 1;
        const xr = toBtxNumber(superChildRow.xr) || 1;
        const gear = toBtxNumber(superChildRow.gear) || 0;
        const lamp = toBtxNumber(superChildRow.lamp) || 0;
        const acc = toBtxNumber(superChildRow.acc) || 0;

        const calculatedValue = cost * flt * xr + (gear + lamp + acc);
        superChildRow.unit_cost = this.accountingToFixedFive(
          toBtxNumber(calculatedValue)
        );
        const unit_cost = toBtxNumber(superChildRow.unit_cost) || 0;

        const required_quantity =
          toBtxNumber(superChildRow.required_quantity) || 0;
        const proquantity = toBtxNumber(superChildRow.proquantity) || 1;

        let unitsellValue = 0;

        if (required_quantity > 0 && proquantity > 0) {
          unitsellValue =
            (toBtxNumber(superChildRow.pro_unit_selling) * proquantity) /
            required_quantity;
        }

        superChildRow.unit_selling = this.accountingRoundup(unitsellValue);

        unitsellValue = toBtxNumber(superChildRow.unit_selling);

        const marginPercent =
          unitsellValue > 0
            ? ((unitsellValue - unit_cost) / unitsellValue) * 100
            : 0;

        superChildRow.margin = this.accountingToFixed(marginPercent);

        // --- Total cost ---
        const total_cost = unit_cost * required_quantity;
        superChildRow.total_cost = this.accountingToFixed(
          toBtxNumber(total_cost)
        );

        // --- Brand Group Qty Logic ---
        let requiredQtyForBrand = 0;
        let pUuid = lineItem.pUuid;

        if (pUuid) {
          for (let c of lineItem.children || []) {
            for (let h of c.header_item || []) {
              if (h?.product === "Brand") {
                requiredQtyForBrand = toBtxNumber(h.required_quantity) || 0;
                break;
              }
            }
          }
        }

        superChildRow.total_selling = this.accountingToFixed(
          toBtxNumber(superChildRow.pro_unit_selling) * requiredQtyForBrand
        );

        superChildRow.isBackwardUpdated = true;

        // Recalculate only totals
        // 1. update child totals (2nd parent)
        this.recalculate_child_totals(parentIndex, childIndex);

        // 2. update line item totals (1st parent)
        this.recalculate_parent_totals(parentIndex);

        // 3. update global totals
        this.recalculate_totals_only();

        // 4. optional: recalc sales %
        this.recalculate_sales_percentages();
        this.emit_values();
        return;
      }

      // ---------------- NORMAL FULL CALCULATION MODE ----------------

      this.total_sales = 0;
      this.total_selling = 0;
      this.total_cost_value = 0;
      this.total_margin = 0;

      let requiredQtyByGroup = {};

      // STEP 1 Brand Qty Mapping
      for (let i = 0; i < this.selected_line_items2?.length; i++) {
        const lineItem = this.selected_line_items2[i];
        if (!lineItem || !lineItem.pUuid) continue;

        for (let j = 0; j < lineItem.children?.length; j++) {
          const child = lineItem.children[j];
          if (!child) continue;

          for (let k = 0; k < child.header_item?.length; k++) {
            const row = child.header_item[k];
            if (!row) continue;

            if (row.product === "Brand") {
              requiredQtyByGroup[lineItem.pUuid] =
                toBtxNumber(row.required_quantity) || 0;
              break;
            }
          }
        }
      }

      // STEP 2 Main Loop
      for (let i = 0; i < this.selected_line_items2?.length; i++) {
        const lineItem = this.selected_line_items2[i];
        if (!lineItem || !lineItem.pUuid) continue;

        const requiredQtyForBrand = requiredQtyByGroup[lineItem.pUuid] || 0;

        for (let j = 0; j < lineItem.children?.length; j++) {
          const child = lineItem.children[j];
          if (!child) continue;

          let totalProRatedUnitSell = 0;
          let totalCost = 0;
          let totalSelling = 0;

          for (let k = 0; k < child.header_item?.length; k++) {
            const row = child.header_item[k];
            if (!row) continue;

            const cost = toBtxNumber(row.cost) || 0;
            const flt = toBtxNumber(row.flt) || 1;
            const xr = toBtxNumber(row.xr) || 1;
            const gear = toBtxNumber(row.gear) || 0;
            const lamp = toBtxNumber(row.lamp) || 0;
            const acc = toBtxNumber(row.acc) || 0;
            const markup = (toBtxNumber(row.margin) || 0) / 100;

            const required_quantity = toBtxNumber(row.required_quantity) || 0;
            const proquantity = toBtxNumber(row.proquantity) || 1;

            const calculatedValue = cost * flt * xr + (gear + lamp + acc);
            row.unit_cost = this.accountingToFixedFive(
              toBtxNumber(calculatedValue)
            );

            const unit_cost = toBtxNumber(row.unit_cost) || 0;

            let unitsellValue =
              unit_cost !== 0 && markup !== 1 ? unit_cost / (1 - markup) : 0;

            row.unit_selling = this.accountingRoundup(
              toBtxNumber(unitsellValue)
            );

            let proRatedUnitSell =
              proquantity !== 0
                ? (this.accountingToFixed(toBtxNumber(row.unit_selling)) *
                    required_quantity) /
                  proquantity
                : 0;

            if (!row.isBackwardUpdated) {
              row.pro_unit_selling = this.accountingToFixed(
                toBtxNumber(proRatedUnitSell)
              );
            }

            const total_cost = unit_cost * required_quantity;
            row.total_cost = this.accountingToFixed(toBtxNumber(total_cost));

            const total_selling =
              toBtxNumber(row.pro_unit_selling) * requiredQtyForBrand;

            row.total_selling = this.accountingToFixed(total_selling);

            totalProRatedUnitSell += toBtxNumber(row.pro_unit_selling) || 0;
            totalCost += total_cost;
            totalSelling += total_selling;
          }

          child.p_unit_selling = this.accountingToFixed(totalProRatedUnitSell);
          child.p_total_saling = this.accountingToFixed(totalSelling);
          child.p_total_cost = this.accountingToFixed(totalCost);

          this.total_selling += totalSelling;
          this.total_cost_value += totalCost;
        }
      }

      // STEP 3 Margin
      this.total_margin =
        this.total_selling && this.total_cost_value
          ? ((this.total_selling - this.total_cost_value) /
              this.total_selling) *
            100
          : 0;

      // Discounts — unchanged
      this.main_discount = 0;
      if (this.discount_type == 1) {
        if (this.discount_value > this.total_selling) {
          this.discount_value = this.total_selling;
        }
        this.main_discount = toBtxNumber(this.discount_value);
      }
      if (this.discount_type == 2) {
        if (this.discount_value > 100) this.discount_value = 100;
        this.main_discount =
          (toBtxNumber(this.total_selling) * toBtxNumber(this.discount_value)) /
          100;
      }

      this.lump_sum_discount = 0;
      if (this.lump_discount_type == 1) {
        if (this.lump_discount_value > this.total_selling) {
          this.lump_discount_value = this.total_selling;
        }
        this.lump_sum_discount = toBtxNumber(this.lump_discount_value);
      }
      if (this.lump_discount_type == 2) {
        if (this.lump_discount_value > 100) this.lump_discount_value = 100;
        this.lump_sum_discount =
          (toBtxNumber(this.total_selling) *
            toBtxNumber(this.lump_discount_value)) /
          100;
      }

      this.grand_total =
        this.total_selling - this.main_discount - this.lump_sum_discount;
      this.grand_total = toBtxNumber(this.grand_total);

      // Sales %
      for (let a = 0; a < this.selected_line_items2?.length; a++) {
        const lineItem = this.selected_line_items2[a];
        if (!lineItem) continue;

        let totalSales = 0;

        for (let b = 0; b < lineItem.children?.length; b++) {
          const child = lineItem.children[b];
          if (!child) continue;

          for (let c = 0; c < child.header_item?.length; c++) {
            const row = child.header_item[c];
            if (!row) continue;

            const total_selling = toBtxNumber(row.total_selling) || 0;

            const total_sales =
              this.total_selling > 0
                ? (total_selling / this.total_selling) * 100
                : 0;

            row.total_sales = this.accountingToFixed(total_sales);
            totalSales += total_sales;
          }

          child.p_total_sales = this.accountingToFixed(totalSales);
        }
      }

      this.emit_values();
    },

    recalculate_totals_only() {
      this.total_selling = 0;
      this.total_cost_value = 0;

      for (const lineItem of this.selected_line_items2 || []) {
        if (!lineItem) continue;

        this.total_selling += toBtxNumber(lineItem.total_selling) || 0;
        this.total_cost_value += toBtxNumber(lineItem.total_cost) || 0;
      }

      this.total_margin =
        this.total_selling > 0
          ? ((this.total_selling - this.total_cost_value) /
              this.total_selling) *
            100
          : 0;

      // discounts
      this.main_discount = 0;
      if (this.discount_type == 1)
        this.main_discount = Math.min(
          toBtxNumber(this.discount_value),
          this.total_selling
        );

      if (this.discount_type == 2)
        this.main_discount =
          (this.total_selling * toBtxNumber(this.discount_value)) / 100;

      this.lump_sum_discount = 0;
      if (this.lump_discount_type == 1)
        this.lump_sum_discount = Math.min(
          toBtxNumber(this.lump_discount_value),
          this.total_selling
        );

      if (this.lump_discount_type == 2)
        this.lump_sum_discount =
          (this.total_selling * toBtxNumber(this.lump_discount_value)) / 100;

      this.grand_total =
        this.total_selling - this.main_discount - this.lump_sum_discount;
    },
    recalculate_parent_totals(parentIndex) {
      const lineItem = this.selected_line_items2[parentIndex];
      if (!lineItem) return;

      let totalSelling = 0;
      let totalCost = 0;

      for (const child of lineItem.children || []) {
        totalSelling += toBtxNumber(child.p_total_saling) || 0;
        totalCost += toBtxNumber(child.p_total_cost) || 0;
      }

      lineItem.total_selling = this.accountingToFixed(totalSelling);
      lineItem.total_cost = this.accountingToFixed(totalCost);
    },
    recalculate_child_totals(parentIndex, childIndex) {
      const lineItem = this.selected_line_items2[parentIndex];
      if (!lineItem) return;

      const child = lineItem.children[childIndex];
      if (!child) return;

      let totalProRatedUnitSell = 0;
      let totalCost = 0;
      let totalSelling = 0;
      /* let totalSales = 0; */

      for (const row of child.header_item || []) {
        if (!row) continue;

        totalProRatedUnitSell += toBtxNumber(row.pro_unit_selling) || 0;
        totalCost += toBtxNumber(row.total_cost) || 0;
        totalSelling += toBtxNumber(row.total_selling) || 0;
      }

      child.p_unit_selling = this.accountingToFixed(totalProRatedUnitSell);
      child.p_total_saling = this.accountingToFixed(totalSelling);
      child.p_total_cost = this.accountingToFixed(totalCost);
    },

    recalculate_sales_percentages() {
      for (const lineItem of this.selected_line_items2 || []) {
        for (const child of lineItem.children || []) {
          let childSales = 0;

          for (const row of child.header_item || []) {
            const totalSelling = toBtxNumber(row.total_selling) || 0;

            const totalSales =
              this.total_selling > 0
                ? (totalSelling / this.total_selling) * 100
                : 0;

            row.total_sales = this.accountingToFixed(totalSales);
            childSales += totalSales;
          }

          child.p_total_sales = this.accountingToFixed(childSales);
        }
      }
    },

    getFilteredProductType(headerItems, currentItemProduct) {
      const isBrandSelected = headerItems.some(
        (item) => item.product === "Brand"
      );
      return this.productType.map((product) => ({
        ...product,
        disabled:
          product.value === "Brand" &&
          isBrandSelected &&
          currentItemProduct !== "Brand",
      }));
    },

    disabledSelection(item, product) {
      item.product = product;
    },

    onParentDragEnd() {
      this.drag = false;
      this.$nextTick(() => {
        this.updateParentOrder();
        this.emit_values();
      });
    },
    onChildDragEnd() {
      this.drag = false;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    onItemDragEnd() {
      this.drag = false;
      this.$nextTick(() => {
        this.calculate_total();
        this.emit_values();
      });
    },
    updateParentOrder() {
      if (Array.isArray(this.selected_line_items2)) {
        this.selected_line_items2.forEach((parent, index) => {
          if (parent) {
            parent.order = index + 1;
          }
        });
      }
    },
    emit_values() {
      this.updateParentOrder();
      this.$nextTick(() => {
        this.$store.dispatch(SET_CALCULATION, {
          total_selling: this.formatNumber(this.total_selling),
          total_cost_value: this.formatNumber(this.total_cost_value),
          total_margin: this.formatNumber(this.total_margin),
          discount_value: this.discount_value,
          discount_type: this.discount_type,
          main_discount: this.main_discount,
          lump_discount_value: this.lump_discount_value,
          lump_discount_type: this.lump_discount_type,
          lump_sum_discount: this.lump_sum_discount,
          discounted_total_selling: this.formatNumber(
            this.discounted_total_selling
          ),
          grand_total: this.formatNumber(this.grand_total),
        });
        this.$store.dispatch(SET_LINE_ITEM, this.selected_line_items2);
        this.$store.dispatch(SET_CALCULATION_LOADING, false);
      });
    },
  },
  mounted() {
    // Synchronize initial scroll position if needed
    this.calculate_total();
    this.getOptions();
    this.$nextTick(() => {
      if (this.$refs.topScrollbar && this.$refs.scrollContainer) {
        this.$refs.topScrollbar.scrollLeft =
          this.$refs.scrollContainer.scrollLeft;
      }
    });
  },
  watch: {
    v2EditLineItem() {
      this.selected_line_items2 = this.v2EditLineItem;
      this.emit_values();
      /*  this.calculate_total(); */
    },
    v2EditCalculation() {
      this.total_selling = this.v2EditCalculation?.total_selling;
      this.total_cost_value = this.v2EditCalculation?.total_cost_value;
      this.total_margin = this.v2EditCalculation?.total_margin;
      this.discount_value = this.v2EditCalculation?.discount_value;
      this.discount_type = this.v2EditCalculation?.discount_type;
      this.main_discount = this.v2EditCalculation?.main_discount;
      this.lump_discount_value = this.v2EditCalculation?.lump_discount_value;
      this.lump_discount_type = this.v2EditCalculation?.lump_discount_type;
      this.lump_sum_discount = this.v2EditCalculation?.lump_sum_discount;
      this.discounted_total_selling =
        this.v2EditCalculation?.discounted_total_selling;
      this.grand_total = this.v2EditCalculation?.grand_total;
      this.emit_values();
      /*  this.calculate_total(); */
    },
  },
  computed: {
    ...mapGetters([
      "v2UomList",
      "v2BrandList",
      "v2ModelList",
      "v2PartList",
      "v2ProductType",
      "v2CurrencyList",
      "vPropertyId",
      "vPropertyContactId",
      "vBillingId",
      "vBillingContactId",
      "reCustomerDialog",
      "vSelectedLineItem",
      "vCalculations",
      "v2EditLineItem",
      "v2EditCalculation",
    ]),
  },
  components: {
    Draggable,
    DeleteSmallConfirm,
    TextAreaField,
    ManageUnit,
  },
};
</script>
<style scoped>
.line-item-drag-group {
  position: relative;
}
.custom-grey-border .color-custom-blue:nth-child(1) {
  position: sticky;
  left: 0;
  background: #f5f5f5;
}
.custom-grey-border .color-custom-blue:nth-child(2) {
  position: sticky;
  left: 30px;
  background: #f5f5f5;
}
.custom-grey-border .color-custom-blue:nth-child(3) {
  position: sticky;
  left: 235px;
  background: #f5f5f5;
}
.custom-grey-border .color-custom-blue:nth-child(4) {
  position: sticky;
  left: 440px;
  background: #f5f5f5;
}
.custom-grey-border .color-custom-blue:last-child {
  position: sticky;
  right: 0px;
  background: #f5f5f5;
}

.line-item-drag .product_header .freeze-column:first-child {
  position: sticky;
  left: 0px;
  background: #e0f7fa !important;
  z-index: 9;
}
.line-item-drag .product_header .freeze-column:nth-child(2) {
  position: sticky;
  left: 30px;
  background: #e0f7fa !important;
  z-index: 7;
}
.line-item-drag .freeze-column:nth-child(1) {
  position: sticky;
  left: 0px;
  /* background: #fff !important; */
  z-index: 15;
}

.line-item-drag .freeze-column:nth-child(2) {
  position: sticky;
  left: 30px;
  background: #fff !important;
  z-index: 13;
}
.line-item-drag .freeze-column:nth-child(3) {
  position: sticky;
  left: 235px;
  background: #fff !important;
  z-index: 13;
}
.line-item-drag .freeze-column:nth-child(4) {
  position: sticky;
  left: 440px;
  background: #fff !important;
  z-index: 13;
}
.line-item-drag .highlighted {
  background: antiquewhite;
}

.line-item-drag .product_header .last-child:last-child {
  position: sticky;
  right: 0px;
  z-index: 7;
  background: #e0f7fa;
}
.line-item-drag .last-child:last-child {
  position: sticky;
  right: 0px;
  z-index: 7;
  background: #fff;
}

.line-item-v2 .line-item-drag {
  padding-top: 0px;
  padding-bottom: 0px;
}
.line-item-v2 .line-item-drag .freeze-column {
  margin: 2px 0px;
}
.line-item-v2 li.line-item-drag:nth-child(even) {
  background: no-repeat !important;
}
.line-item-v2 li.line-item-drag.header_color .product_header {
  background: rgb(217 214 214 / 64%) !important;
}
.line-item-v2 li.line-item-drag.header_color .product_header .freeze-column {
  background: rgb(217 214 214 / 64%) !important;
}
.line-item-v2 li.line-item-drag.header_color .product_header .last-child {
  background: rgb(217 214 214 / 64%) !important;
}
/* scroll css */
.custom-grey-border {
  position: relative;
}

.scrollbar-wrapper {
  overflow: hidden;
}

.scrollbar {
  height: 10px; /* Same height as bottom scrollbar */
  overflow-x: scroll;
  background-color: transparent;
}

.scrollbar .scroll-content {
  height: 1px;
  background-color: transparent;
  width: 2697px;
}

.content-wrapper {
  height: auto; /* Adjust height as needed */
}

.scrollbar::-webkit-scrollbar {
  height: 10px;
}

.scrollbar::-webkit-scrollbar-thumb {
  background-color: #ccc; /* Style scrollbar thumb */
  border-radius: 0px;
}

.scrollbar::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep(.custom-z-index) {
  z-index: 9999 !important;
}
::v-deep .v-application .v-menu__content {
  z-index: 20 !important;
}
</style>
